import { useSelector } from "react-redux";
import {
  UserDetails,
  PagePermissions,
  canWrite,
  isUserCeo,
  canAccessPage,
  canManageReportSettings,
  canManageUsers,
  canManageMeetingRecord,
  isOwnerOrSuccessManager} from "../Services/Permissions";

export const usePermissions = () => {
  const loggedInuserDetails: UserDetails = useSelector(
    (state: any) => state?.authReducer?.userDetails
  );
  
  const pagePermissions: PagePermissions = useSelector(
    (state: any) => state?.authReducer?.pagePermissions
  );

  return {
    user: loggedInuserDetails,
    pagePermissions,

    canWrite: canWrite(loggedInuserDetails),
    isCeo: isUserCeo(loggedInuserDetails),
    isShareholder: !!loggedInuserDetails?.is_shareholder,
    isSuccessManager: !!loggedInuserDetails?.is_success_manager,

    canAccess: (pageKey: keyof PagePermissions) =>
      canAccessPage(loggedInuserDetails, pagePermissions, pageKey),

    canManageSettings: (resourceOwnerId: string | null | undefined) =>
      canManageReportSettings(loggedInuserDetails, resourceOwnerId),
      
    canManageUsers: canManageUsers(loggedInuserDetails),
    
    canManageMeetingRecord: (resourceOwnerId: string | null | undefined) =>
      canManageMeetingRecord(loggedInuserDetails, resourceOwnerId),
      
    isOwnerOrSuccessManager: (resourceOwnerId: string | null | undefined) =>
      isOwnerOrSuccessManager(loggedInuserDetails, resourceOwnerId)};
};
